import { render, staticRenderFns } from "./identification.vue?vue&type=template&id=67322610&"
import script from "./identification.vue?vue&type=script&lang=ts&"
export * from "./identification.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports